import React from 'react';
import './Experience.css';
import { FaBriefcase, FaChartLine, FaRoute, FaBoxes, FaMicrophone, FaRobot, FaServer } from 'react-icons/fa';

const experiences = [
  {
    role: 'AI/ML Intern',
    company: 'Nexyuga Innovattions',
    period: 'Feb 2026 - Present',
    location: 'Tamil Nadu, India',
    points: [
      {
        icon: <FaMicrophone />,
        text: 'Spearheading the development of an end-to-end speech-to-speech (STS) pipeline designed to make educational content more accessible.'
      },
      {
        icon: <FaRobot />,
        text: 'Orchestrating custom prompt flows with LangGraph while experimenting with various open-source LLMs to find the perfect balance of speed and accuracy.'
      },
      {
        icon: <FaServer />,
        text: 'Developing and testing the Linux-based STS pipeline on GCP Virtual Machines, with a focus on reliability before production deployment.'
      }
    ]
  },
  {
    role: 'Data Analyst Intern',
    company: 'Earthy Origins',
    period: 'Jul 2024 - Jun 2025',
    location: 'Tamil Nadu, India',
    points: [
      {
        icon: <FaChartLine />,
        text: 'Transformed raw Shopify data into intuitive visual stories and dashboards that guided daily operations, inventory forecasting, and sales tracking.'
      },
      {
        icon: <FaRoute />,
        text: 'Brought data to the real world by optimizing delivery routes with heat maps and introducing traceability tools for the warehouse team.'
      },
      {
        icon: <FaBoxes />,
        text: 'Delivered cross-functional insights that empowered the marketing, operations, and finance teams to step away from guesswork and make confident, data-backed decisions.'
      }
    ]
  }
];

const Experience = () => {
  return (
    <section id="experience" className="experience section">
      <div className="container">
        <h2 className="section-title">Internship Experience</h2>
        <p className="section-subtitle">
          Real projects delivered in production-like environments across analytics and AI.
        </p>

        <div className="experience-list">
          {experiences.map((item) => (
            <article key={item.company} className="experience-card">
              <div className="experience-head">
                <div className="experience-role-wrap">
                  <span className="experience-role-icon"><FaBriefcase /></span>
                  <div>
                    <h3 className="experience-role">{item.role}</h3>
                    <p className="experience-company">{item.company}</p>
                  </div>
                </div>
                <div className="experience-meta">
                  <span>{item.period}</span>
                  <span>{item.location}</span>
                </div>
              </div>

              <ul className="experience-points">
                {item.points.map((point) => (
                  <li key={point.text}>
                    <span className="experience-point-icon">{point.icon}</span>
                    <span>{point.text}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
